import { ReactNode, useCallback } from 'react'

import { Scope } from '../../../../enums/scope'
import { isAuthorized } from '../../../../utils/isAuthorized'
import { useCreateFolderModal } from '../../contexts/CreateFolderModalContext'
import { useDmsUserRole } from '../../hooks/useDmsUserRole'
import { CreateFolderButton } from '../CreateFolderButton'
import { FolderTree } from '../FolderTree'
import { SharedByMeNavItem } from '../SharedByMeNavItem'
import { UnsortedNavItem } from '../UnsortedNavItem'
import * as Styled from './styles'

interface DocumentsLayoutProps {
  children: ReactNode
}

export const DocumentsLayout = ({ children }: DocumentsLayoutProps) => {
  const { openCreateFolderModal } = useCreateFolderModal()

  const handleCreateFolderClick = useCallback(() => {
    openCreateFolderModal(null) // null corresponds to root folder
  }, [openCreateFolderModal])
  const { isBoWithoutCpa, isCpaExpertMode } = useDmsUserRole()

  const showCreateFolderButton = (isCpaExpertMode || isBoWithoutCpa) && isAuthorized(Scope.DmsFolderWrite)

  return (
    <Styled.DocumentsLayoutWrapper>
      <Styled.Sidebar>
        <Styled.MenuButtonSpacer />
        <UnsortedNavItem />
        <SharedByMeNavItem />
        <FolderTree />
        {showCreateFolderButton && <CreateFolderButton onClick={handleCreateFolderClick} />}
      </Styled.Sidebar>
      <Styled.Content>{children}</Styled.Content>
    </Styled.DocumentsLayoutWrapper>
  )
}
